export var PaymentDelayDayType;
(function (PaymentDelayDayType) {
    PaymentDelayDayType[PaymentDelayDayType["Unknown"] = 0] = "Unknown";
    PaymentDelayDayType[PaymentDelayDayType["Calendar"] = 1] = "Calendar";
    PaymentDelayDayType[PaymentDelayDayType["Working"] = 2] = "Working";
})(PaymentDelayDayType || (PaymentDelayDayType = {}));
